import script from "./ListChurch.vue?vue&type=script&setup=true&lang=js"
export * from "./ListChurch.vue?vue&type=script&setup=true&lang=js"

import "./ListChurch.vue?vue&type=style&index=0&id=40ed29ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ed29ea"]])

export default __exports__